const MobileNavCurrentTab = ({ tabs, tabIndex }) => {
  const currentTab = tabs.find(tab => tab.value === tabIndex);
  return currentTab.component || null;
};

export default MobileNavCurrentTab;
